import React, { Component, Fragment } from "react";
import Calendar from "../common/Calendar";
import HotModIndicator from "../common/HotModIndicator";

class Header extends Component {
  state = {
    selected: "",
    poNote: false,
    isTheLastSuffix: false
  };
  constructor() {
    super();
    this.statuses = { O: "O-OPEN", R: "R-RECV", C: "C-CANC", H: "H-HOLD" };
    this.whses = {
      5: "FIXTURES",
      6: "DIRECT SHIP",
      10: "ONTARIO CA",
      11: "LAVONIA GA",
      20: "HAZLETON",
      22: "LEXINGTON TN",
      30: "REDLANDS CA",
      33: "DANVILLE IL",
      44: "LAFAYETTE LA",
      52: "LAREDO TX",
      54: "TEPEJI DEL RIO",
      55: "DALLAS",
      57: "LAREDO DC (DC 57)",
      58: "MONTERREY",
      66: "OCALA",
      68: "SHANGHAI ASIAN DEV INTL TRANS",
      69: "CUSTOM GOODS LLC",
      71: "DENVER",
      72: "SALT LAKE CITY",
      77: "PHOENIX AZ",
      81: "NORTHEASTERN DOMICILE",
      85: "TEPEJI DEL RIO",
      86: "HERMOSILLO",
      87: "SEAGOVILLE",
      88: "PASCO",
      91: "VENDOR DIRECT PARTS (VDP)",
      92: "STORE SUPPLY",
      93: "SMS SHOP"
    };
    this.defaultArrivalDate = "";
    this.defaultPoNote = "";
  }
  renderSufixDpdwn() {
    if (this.props.suffixes) {
      return this.props.suffixes.map(suffix => {
        return (
          <Fragment key={suffix.suffix}>
            <option value={suffix.suffix}>0{suffix.suffix}</option>
          </Fragment>
        );
      });
    }
  }
  checkStatus = () => {
    if (this.props.data.status === "O") {
      this.props.activateCloseButton(true);
    }
  };

  componentDidMount() {
    this.checkStatus();
  }
  componentDidUpdate() {
    this.props.headerNewData
      ? (this.defaultPoNote = this.props.headerNewData.poNote)
      : (this.defaultPoNote = this.props.data.poNote);
    this.props.headerNewData
      ? (this.defaultArrivalDate = this.props.headerNewData.arrivalDate)
      : (this.defaultArrivalDate = this.props.data.arrivalDate);
    if (
      this.state.isTheLastSuffix !==
      (this.props.data.maxSuffix === this.props.data.suffix)
    ) {
      this.setState({
        isTheLastSuffix: this.props.data.maxSuffix === this.props.data.suffix
      });
    }

    if (
      (this.state.poNote && this.state.poNote !== this.defaultPoNote) ||
      (this.state.newArrivalDate !== undefined &&
        this.state.newArrivalDate !== this.defaultArrivalDate)
    ) {
      this.props.headerUpdate(
        {
          headerUpdate: {
            poNote: this.state.poNote ? this.state.poNote : this.defaultPoNote,
            arrivalDate: this.state.newArrivalDate
              ? this.state.newArrivalDate
              : this.defaultArrivalDate,
            poNumber: this.props.data.poNumber,
            suffix: this.props.data.suffix,
            status: this.props.data.status,
            shipDate: this.props.data.shipDate
          }
        },
        true
      );
    } else {
      this.props.headerUpdate({ headerUpdate: null }, false);
    }
  }

  setReadOnly(bool) {
    this.setState({ isReadOnly: true });
  }

  getDate = date => {
    const formatedDate =
      date.getFullYear() +
      "-" +
      (date.getMonth() < 10
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1) +
      "-" +
      (date.getDate() < 10 ? "0" + date.getDate() : date.getDate());

    var shipDate = this.props.data.shipDate
      ? new Date(this.props.data.shipDate)
      : new Date();

    if (Math.ceil((shipDate - date) / (1000 * 3600 * 24)) <= -3) {
      this.setState({ newArrivalDate: formatedDate });
    } else {
      this.props.sendErrorMsg("Ship and Arrival Dates must be 3 days apart");
    }
    this.props.closeModal();
  };

  render() {
    return (
      <div className="grid-container">
        <div className="input-group element el21">
          <div className="input-group-prepend">
            <span className="input-group-text">PO Number</span>
          </div>
          <input
            type="text"
            value={this.props.data.poNumber ? this.props.data.poNumber : ""}
            className="form-control"
            readOnly
          />
        </div>
        <div className={`input-group element el22`}>
          <div className="input-group-prepend">
            <span className="input-group-text">Suffix</span>
          </div>
          <select
            type="text"
            className={`form-control input22`}
            onMouseDown={e => this.props.clickSuffix()}
            onChange={e =>
              this.props.changeSuffix(this.props.suffixes[e.target.value])
            }
            value={this.props.data.suffix}
          >
            {this.props.isSuffixSelectionActive ? (
              this.renderSufixDpdwn()
            ) : (
              <option>0{this.props.data.poh_suffix}</option>
            )}
          </select>
        </div>
        <div className={`input-group element el23`}>
          <div className="input-group-prepend">
            <span className="input-group-text">Item</span>
          </div>
          <input
            type="text"
            className={`form-control input23`}
            value={this.props.itemLookup}
            onChange={e => this.props.onChange(e.target.value)}
          />
        </div>
        <div className={`input-group element el24`}>
          <div className="input-group-prepend">
            <span className="input-group-text">PM</span>
          </div>
          <input
            type="text"
            className={`form-control input24`}
            value={this.props.data.pm ? this.props.data.pm : ""}
            readOnly
          />
        </div>
        <div className={`input-group element el25`}>
          <div className="input-group-prepend">
            <span className="input-group-text">Received</span>
          </div>
          <input
            type="text"
            className={`form-control input25`}
            readOnly
            value={
              this.props.data.receivedDate ? this.props.data.receivedDate : ""
            }
          />
        </div>
        <div className={`input-group element el26`}>
          <div className="input-group-prepend">
            <span className="input-group-text">Warehouse</span>
          </div>
          <input
            type="text"
            className={`form-control input26`}
            readOnly
            value={this.props.data.whse ? this.whses[this.props.data.whse] : ""}
          />
        </div>
        <div className={`input-group element el27`}>
          <div className="input-group-prepend">
            <span className="input-group-text">Status</span>
          </div>
          {/* // eslint-disable-next-line */}
          <input
            type="text"
            className={`form-control input27`}
            readOnly
            value={
              // this.props.data.status && this.props.newStatus === false
              //   ?
              this.statuses[this.props.data.status]
              // : this.statuses[this.props.newStatus]
            }
          />
        </div>
        <div className={`input-group element el28`}>
          <div className="input-group-prepend">
            <span className="input-group-text">Alt Vendor</span>
          </div>
          <input
            type="text"
            className={`form-control input28`}
            readOnly
            value={
              this.props.data.alternateVndr ? this.props.data.alternateVndr : ""
            }
          />
        </div>
        <div className={`input-group element el29`}>
          <div className="input-group-prepend">
            <span className="input-group-text">Vendor</span>
          </div>
          <input
            type="text"
            className={`form-control input29`}
            readOnly
            value={this.props.data.apVndr ? this.props.data.apVndr : ""}
          />
        </div>
        <div className={`input-group element el210`}>
          <div className="input-group-prepend">
            <span className="input-group-text">Vendor Name</span>
          </div>
          <input
            type="text"
            className={`form-control input210`}
            readOnly
            value={this.props.data.vendorName ? this.props.data.vendorName : ""}
          />
        </div>
        <div className={`input-group element el211`}>
          <div className="input-group-prepend">
            <span className="input-group-text">Created</span>
          </div>
          <input
            type="text"
            className={`form-control input211`}
            readOnly
            value={this.props.data.createDate ? this.props.data.createDate : ""}
          />
        </div>
        <div className={`input-group element el212`}>
          <div className="input-group-prepend">
            <span className="input-group-text">Modified</span>
          </div>
          <input
            type="text"
            className={`form-control input212`}
            readOnly
            value={
              this.props.data.lastModified ? this.props.data.lastModified : ""
            }
          />
        </div>
        <div className={`input-group element el213`}>
          <div className="input-group-prepend">
            <span className="input-group-text">Date To Arrive</span>
          </div>

          <input
            className={`form-control input213`}
            onChange={e =>
              this.setState({ newArrivalDate: this.defaultArrivalDate })
            }
            value={
              this.state.newArrivalDate
                ? this.state.newArrivalDate
                : this.defaultArrivalDate
            }
            onClick={
              this.props.data.status !== "O" && this.props.data.status !== "H"
                ? null
                : e =>
                    this.props.openModal(
                      "success",
                      "Input...",
                      <Calendar getDate={this.getDate} />,
                      "format_list_bulleted",
                      "Close"
                    )
            }
            readOnly={
              !(
                this.props.data.status === "O" || this.props.data.status === "H"
              )
            }
          />
          {this.state.newArrivalDate &&
          this.state.newArrivalDate !== this.defaultArrivalDate ? (
            <div className="hotmod-wrapper">
              <HotModIndicator />
            </div>
          ) : null}
        </div>
        <div className={`input-group element el214`}>
          <div className="input-group-prepend">
            <span className="input-group-text">PO Note</span>
          </div>
          <input
            type="text"
            className={`form-control input214`}
            onChange={e => this.setState({ poNote: e.target.value })}
            onBlur={e =>
              e.target.value === ""
                ? this.setState({ poNote: this.defaultPoNote })
                : null
            }
            // defaultValue={this.defaultPoNote}
            value={
              this.state.poNote === false
                ? this.defaultPoNote
                : this.state.poNote
            }
            readOnly={
              !(
                this.props.data.suffix === this.props.data.maxSuffix &&
                (this.props.data.status === "O" ||
                  this.props.data.status === "H")
              )
            }
          />
          {this.state.poNote !== false &&
          this.state.poNote !== this.defaultPoNote ? (
            <div className="hotmod-wrapper">
              <HotModIndicator />
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}

export default Header;
